import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Feature, Title } from '@vds/typography';
import PropTypes from 'prop-types';
import { FlexColumnGap } from './commonStyles';
import Footer from './footer';

const TimeoutContainer = styled.div`
    padding: 4rem 4rem 0.5rem 4rem;
    box-sizing: border-box;
    height: 60%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    h1{font-weight: 400;} 
    background: #FFFFFF;
    border-radius: 32px;
    position: relative;
    z-index:6000000 !important;
`;

const OverlayContainer = styled.div`
    width: 100% !important;
    height: 100% !important;
    position: fixed;
    background: rgba(0,0,0, 0.7);
    z-index: 9990000 !important;
    top: 0px !important;
    left: 0px !important;
`;
const TimerContainer = styled.div`
    background: #F6F6F6;
    border-radius: 100px;
    height: 25px;
`;
const TimerWrapper = styled.div`
    background: #EE0000;
    border-radius: 100px;
    height: 25px;
    width: ${({ timerPer }) => `${timerPer}%;`}
`;

const ModelContainer = styled.div`
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%, -50%);
    color: white; background: #666666; opacity: .8;
    z-index: 10000000 !important;
    width: 65%;
`
const TextContainer = styled.div`
    text-align: inherit;
`

const TimeContainer = styled.div`
    text-align: center;
    margin-top: 2rem;
`

const Timeout = (props) => {
  const { continueClick, endSessionClick } = props;
  const warningTimer =  15 * 1000;
  const timeInSeconds = warningTimer / 1000;
  const [timer, setTimer] = useState(timeInSeconds);
  const [timerPercentage, setTimerPercentage] = useState(100);
  let timerId = '';
  const decrementCounter =  Math.ceil(timeInSeconds /100);

  useEffect(() => {
    timerId = setTimeout(() => {
      const time = timer - 1;
      setTimer(time);
      setTimerPercentage(parseFloat(timer/timeInSeconds).toPrecision(2) * 100);
      if (time === 0) { endSessionClick(); }
    }, 1000);
    return () => clearTimeout(timerId);
  }, [timer]);
  const continueHelper = () => {
    clearTimeout(timerId);
    continueClick();
  };
  const endSessionHelper = () => {
    clearTimeout(timerId);
    endSessionClick();
  };

  const buttonData = {
    borderTop: false,
    flexDirection: 'row',
    gap: 20,
    buttonGroup: [ {
      disabled: false,
      text: 'Continue',
      use: 'primary',
      onClick: continueHelper,
      dataTrack: 'continue_session',
    }, {
      disabled: false,
      text: 'End Session',
      use: 'secondary',
      onClick: endSessionHelper,
      dataTrack: 'end_session',
    },],
  };
  const mins = parseInt(timer / 60);
  let seconds = timer % 60;
  if (seconds < 10) {
    seconds = `0${seconds}`;
  }

  return (
    <OverlayContainer>
      <ModelContainer>
        <TimeoutContainer>
            <FlexColumnGap gap={64}>
              <Feature color="#1B1D1F" size="XSmall" primitive="h1" bold={false}><TextContainer>Still there?</TextContainer></Feature>
              <FlexColumnGap gap={24}>
                <TimerContainer>
                  <TimerWrapper timerPer={timerPercentage} />
                </TimerContainer>
                   <Title color="#000000" size="medium" primitive="p" bold={false}>
                     Your session will expire in 
                     {` 0${mins}:${seconds}`}
                   </Title>
              </FlexColumnGap>
            </FlexColumnGap>
            <Footer flexDirection={buttonData?.flexDirection} buttonData={buttonData?.buttonGroup} />
          </TimeoutContainer>
      </ModelContainer>
    </OverlayContainer>
  );
};
Timeout.propTypes = {
  continueClick: PropTypes.func,
  endSessionClick: PropTypes.func,
};
export default Timeout;
